import React, { useEffect } from 'react'
import Navbar from '../../../components/organism/navbar/index.tsx'
import './index.css'
import ContactForm from '../../../components/organism/contactForm/index.tsx'
import Footer from '../../../components/organism/footer/index.tsx'
import PriceSection from '../../../components/organism/priceSection/index.tsx'
import PurchaseFlow from '../../../components/organism/purchaseFlow/index.tsx'
import MarketingSeo from '../../../components/marketingSeo/index.tsx'

const Price : React.FC = () => {
	// run this function from an event handler or an effect to execute scroll
	useEffect(() => {
		// if (loaderShown) {
		document.querySelector('.body-container')?.classList.add('position-initial')
		// }

		setTimeout(() => {
			window.scrollTo({ top: 0 })
		}, 200)
	}, [])

	return (
		<div >
			<MarketingSeo page='price' />
			<Navbar scrollToContact={() => {}} />

			<PriceSection headingLevel={1} />
			<PurchaseFlow />
			<ContactForm />

			<Footer />
		</div>
	)
}

export default Price
